import React from 'react';
import { View, Text, TouchableOpacity, Alert } from 'react-native';
import { IConnectionStatusProps } from '../types';
import { useTranslation } from 'react-i18next';
import LoadingSpinner from '@shared/components/md-design-system/Layout/LoadingSpinner';

export const ConnectionStatus: React.FC<IConnectionStatusProps> = ({
    isConnecting,
    isConnected,
    connectionError,
    onReconnect,
}) => {
    const handleReconnect = async () => {
        try {
            await onReconnect();
        } catch (error) {
            Alert.alert(
                t('commons.connection.connectionError'),
                t('commons.connection.failedToConnect'),
                [{ text: 'OK' }]
            );
        }
    };

    const { t } = useTranslation();

    if (isConnecting) {
        return (
            <View className="flex-1 justify-center items-center px-8">
                <LoadingSpinner size="large" color="primary" />
                <Text className="font-medium text-base mt-8">{t('commons.connection.connecting')}</Text>
            </View>
        );
    }

    if (!isConnected || connectionError) {
        return (
            <View className="flex-1 justify-center items-center px-8">
                <Text className="font-bold mb-2">{t('commons.connection.failedToConnect')}</Text>
                {connectionError && (
                    <Text className="text-gray-600 mb-6 text-center">
                        {connectionError}
                    </Text>
                )}
                <TouchableOpacity
                    className="bg-primary-700 rounded-lg py-4 items-center mb-3 w-full"
                    onPress={handleReconnect}
                    disabled={isConnecting}>
                    <Text className="text-white text-[17px] font-semibold">
                        {isConnecting ? t('commons.connection.connecting') : t('commons.connection.reconnect')}
                    </Text>
                </TouchableOpacity>
            </View>
        );
    }

    return null;
};
